export default __webpack_public_path__ + "static/media/hub-active.98b5b6e8.png";